import { useRouter } from "next/router";
import type { PropsWithChildren } from "react";

import { Footer } from "./Footer";
import { Header } from "./Header";
import { Sidemenu } from "./Sidemenu";
import { alpha, Box } from "@mui/material";
import { AUTH_ROUTES } from "@/constants/Routes";
import { blueGrey } from "@mui/material/colors";

const authRoutes = AUTH_ROUTES as string[];

export function Layout({ children }: PropsWithChildren) {
	const { pathname } = useRouter();
	const isAuthPage = authRoutes.includes(pathname);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100vw" }}>
			<Header />
			<Box sx={{ display: "flex", flex: 1, width: "100%", overflowY: "hidden" }}>
				{!isAuthPage && <Sidemenu />}
				<Box
					component="main"
					sx={{
						flex: 1,
						bgcolor: alpha(blueGrey[800], 0.15),
						p: { xs: 1, md: 2, lg: 4 },
						overflowY: "auto",
					}}
				>
					{children}
				</Box>
			</Box>
			<Footer />
		</Box>
	);
}
